import { EditableContent } from '../../edit/EditableContent';
import { pickBlockField } from '../../lib/localized';
import { parseLabeledLines } from '../../lib/parseLabeledLines';
import type { BlockRenderProps } from '../../types';

export function CoffeeSubscriptionMatrix({
  block,
  locale,
  isActive,
  activeEditTarget,
  editable,
}: BlockRenderProps) {
  const sectionTitle = pickBlockField(block.content, 'sectionTitle', locale);
  const supporting = pickBlockField(block.content, 'supporting', locale);
  const plansRaw = pickBlockField(block.content, 'plans', locale);
  const ctaLabel = pickBlockField(block.content, 'ctaLabel', locale);
  const plans = parseLabeledLines(plansRaw);
  const target = isActive ? activeEditTarget : null;

  return (
    <section
      className={['ws-coffee-sub', isActive ? 'ws-block--active' : ''].filter(Boolean).join(' ')}
      data-block-id={block.blockId}
      data-component={block.componentType}
      id="subscribe"
    >
      <div className="ws-coffee-sub__inner">
        <EditableContent
          as="h2"
          fieldKey="sectionTitle"
          editable={editable}
          activeEditTarget={target}
          className="ws-coffee-sub__title"
        >
          {sectionTitle}
        </EditableContent>
        {supporting || editable ? (
          <EditableContent
            fieldKey="supporting"
            editable={editable}
            activeEditTarget={target}
            className="ws-coffee-sub__supporting"
          >
            {supporting}
          </EditableContent>
        ) : null}
        {editable ? (
          <EditableContent
            fieldKey="plans"
            editable={editable}
            activeEditTarget={target}
            className="ws-coffee-sub__editor"
          >
            {plansRaw}
          </EditableContent>
        ) : (
          <ul className="ws-coffee-sub__grid">
            {plans.map((plan, index) => (
              <li key={`${plan.label}-${index}`} className="ws-coffee-sub__plan">
                <p className="ws-coffee-sub__plan-name">{plan.label}</p>
                {plan.meta ? <p className="ws-coffee-sub__plan-meta">{plan.meta}</p> : null}
              </li>
            ))}
          </ul>
        )}
        {ctaLabel ? (
          <EditableContent
            as="a"
            fieldKey="ctaLabel"
            editable={editable}
            activeEditTarget={target}
            className="ws-coffee-sub__cta"
            href="#contact"
          >
            {ctaLabel}
          </EditableContent>
        ) : null}
      </div>
    </section>
  );
}
